// extracted by mini-css-extract-plugin
module.exports = {"container":"Unauthorised_container__KA7Qs","iconColor":"Unauthorised_iconColor__4UnXo","bold":"Unauthorised_bold__+Aocf","light":"Unauthorised_light__/+Fp9"};